import { SettingsService } from "@/services/";
import { constants } from "@/const";
import { mapGetters } from "vuex";
import { formatDateTime } from "@/components/mixins";


export default {
    name: "MessageBanner",
    mixins: [formatDateTime],
    data() {
        return {
            header: '',
            message: '',
            start: null,
            end: null,
            costCenters: null,
        };
    },
    computed: {
        ...mapGetters(["McfCostCenterId"]),
        shouldShowBanner() {
            return this.isCurrentTimeInRange(this.start, this.end) && this.isCostCenterIncluded(this.costCenters)
        }
    },
    created() {
        SettingsService.getAllSettings().then((response) => {
            var settings = response;
            var settingKeys = constants.MLA_BANNER_SETTINGS;
            this.start = _.find(settings, (x) => x.Key == settingKeys.START_DATE)?.Value;
            this.end = _.find(settings, (x) => x.Key == settingKeys.END_DATE)?.Value;
            this.costCenters = _.find(settings, (x) => x.Key == settingKeys.COST_CENTERS)?.Value;

            this.header = _.find(settings, (x) => x.Key == settingKeys.HEADER)?.Value;
            this.message = _.find(settings, (x) => x.Key == settingKeys.MESSAGE)?.Value;

        });
    },
    methods: {
        isCostCenterIncluded(csvString) {
            if (!csvString) {
                return false;
            }
            const costCenterIds = csvString.split(',').map(id => parseInt(id.trim(), 10));
            return costCenterIds.includes(this.McfCostCenterId);
        },      
    },
};